import React from 'react';
import iconify from '../iconify';

const ScaleIcon = ({customColor, ...props}) => (
  <svg
    width="1em"
    height="0.82em"
    viewBox="3554.93 226 63.07 52.022"
    {...props}
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1={1.16}
        y1={1}
        x2={-0.139}
        y2={1}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#d3793b" />
        <stop offset={1} stopColor="#ea4154" />
      </linearGradient>
    </defs>
    <g
      transform="translate(3554.93 226)"
      fill={customColor ? 'currentColor' : 'url(#linear-gradient)'}
    >
      <path
        d="M53.131 10.685a2.05 2.05 0 0 1 1.4.415 4.5 4.5 0 0 0 3.994 1.089 4.4 4.4 0 0 0 3.268-3.475 4.54 4.54 0 0 0-1.4-3.994 4.724 4.724 0 0 0-4.253-.83h-.363l-1.556.156c-.519.052-1.089.1-1.608.156l-.934.1a10.072 10.072 0 0 0-1.245.1 21.7 21.7 0 0 1-3.683.1 3.805 3.805 0 0 1-3.111-1.338A8.941 8.941 0 0 0 37 0a12.9 12.9 0 0 0-1.919.1 8.962 8.962 0 0 0-1.711.522 8.86 8.86 0 0 0-5.239 5.239 3.633 3.633 0 0 1-2.49 2.282 57.443 57.443 0 0 1-10.218 2.645h-.311a4.726 4.726 0 0 0-2.282 1.971 4.616 4.616 0 0 0 0 4.2 4.274 4.274 0 0 0 3.683 2.178h.519a4.419 4.419 0 0 0 3.368-2.28 1.59 1.59 0 0 1 1.193-.778l15.819-2.438 15.716-2.956zm-16.079.726l-15.819 2.334a4.471 4.471 0 0 0-3.008 1.971 2.346 2.346 0 0 1-1.608 1.084h-.207a1.969 1.969 0 0 1-1.608-.985 2.088 2.088 0 0 1 0-1.919 2.067 2.067 0 0 1 .985-.882h.052A57.9 57.9 0 0 0 26.42 10.27a6.2 6.2 0 0 0 3.942-3.631A6.722 6.722 0 0 1 34.3 2.7a9.917 9.917 0 0 1 1.089-.311l.207-.052a6.144 6.144 0 0 1 1.4-.1 6.653 6.653 0 0 1 4.984 2.379 6.527 6.527 0 0 0 4.927 2.23c1.712 0 3.475-.1 5.187-.207l.934-.1c.985-.1 2.075-.207 3.164-.311h.308a3.172 3.172 0 0 1 2.49.207 1.935 1.935 0 0 1 .674 1.815 1.83 1.83 0 0 1-1.4 1.5 2.451 2.451 0 0 1-1.815-.415 4.219 4.219 0 0 0-3.475-.985z"
        transform="translate(-5.932)"
      />
      <path
        d="M93.655 31.656a2.532 2.532 0 0 0-2.282-1.556 2.3 2.3 0 0 0-2.23 1.556l-5.706 10.529c-.415.83-.934 1.763-1.452 2.645a1.174 1.174 0 0 0-.052.934.935.935 0 0 0 .622.622 1.117 1.117 0 0 0 .571.1 1.192 1.192 0 0 0 1.037-.674c.207-.415.415-.83.674-1.3.207-.415.467-.882.674-1.3l5.706-10.622a.312.312 0 0 0 .052-.207v-.415l.207.415c.052.052.1.207.207.259v.052l.83 1.608c1.037 1.867 2.075 3.786 3.112 5.705s2.075 3.838 3.112 5.705a1.227 1.227 0 0 0 .674.571 1.046 1.046 0 0 0 .882-.1 1.227 1.227 0 0 0 .571-.674 1.046 1.046 0 0 0-.1-.882c-1.037-1.867-2.075-3.786-3.112-5.705s-2.075-3.838-3.112-5.705z"
        transform="translate(-39.402 -14.488)"
      />
      <path
        d="M78.8 67.4l.1 1.712a8.346 8.346 0 0 0 3.216 6.068 12.764 12.764 0 0 0 15.56 0 8.163 8.163 0 0 0 3.216-6.068L101 67.4zm19.5 2.49a5.491 5.491 0 0 1-2.178 3.423 9.93 9.93 0 0 1-6.276 2.075 9.827 9.827 0 0 1-6.276-2.075 5.869 5.869 0 0 1-2.28-3.423l-.052-.1H98.3z"
        transform="translate(-37.929 -32.442)"
      />
      <path
        d="M3.6 59.29a1.117 1.117 0 0 0 .571.1 1.192 1.192 0 0 0 1.037-.674c.207-.415.415-.83.674-1.3.207-.415.467-.882.674-1.245l5.705-10.633c.052-.052.052-.207.052-.207v-.415l.207.363c.052.052.1.207.207.259v.062l.83 1.608c1.037 1.867 2.075 3.786 3.112 5.705s2.075 3.838 3.112 5.705a1.2 1.2 0 0 0 2.178-.207 1.046 1.046 0 0 0-.1-.882c-1.037-1.867-2.075-3.786-3.112-5.705s-2.075-3.838-3.112-5.705l-.83-1.66a2.532 2.532 0 0 0-2.28-1.559 2.3 2.3 0 0 0-2.23 1.556l-5.81 10.685c-.415.83-.934 1.712-1.4 2.645a.939.939 0 0 0-.052.83 1.074 1.074 0 0 0 .567.674z"
        transform="translate(-1.425 -20.649)"
      />
      <path
        d="M.1 81.912a8.346 8.346 0 0 0 3.219 6.068 12.273 12.273 0 0 0 7.78 2.645 12.273 12.273 0 0 0 7.78-2.645 8.163 8.163 0 0 0 3.221-6.068l.1-1.712H0zm19.5.622l-.052.156a5.869 5.869 0 0 1-2.282 3.423A9.93 9.93 0 0 1 11 88.188a9.725 9.725 0 0 1-6.28-2.075 5.869 5.869 0 0 1-2.282-3.423l-.052-.1h17.22z"
        transform="translate(0 -38.603)"
      />
    </g>
  </svg>
);

export default iconify(ScaleIcon);
